/* tslint:disable */
/* eslint-disable */
/**
 * ahoy
 * Worlds next gen CRM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrgFlagItem
 */
export interface OrgFlagItem {
    /**
     * 
     * @type {string}
     * @memberof OrgFlagItem
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrgFlagItem
     */
    enabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrgFlagItem
     */
    isGlobal: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrgFlagItem
     */
    note: string;
    /**
     * 
     * @type {Date}
     * @memberof OrgFlagItem
     */
    created: Date | null;
}

/**
 * Check if a given object implements the OrgFlagItem interface.
 */
export function instanceOfOrgFlagItem(value: object): value is OrgFlagItem {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('isGlobal' in value) || value['isGlobal'] === undefined) return false;
    if (!('note' in value) || value['note'] === undefined) return false;
    if (!('created' in value) || value['created'] === undefined) return false;
    return true;
}

export function OrgFlagItemFromJSON(json: any): OrgFlagItem {
    return OrgFlagItemFromJSONTyped(json, false);
}

export function OrgFlagItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrgFlagItem {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'enabled': json['enabled'],
        'isGlobal': json['isGlobal'],
        'note': json['note'],
        'created': (json['created'] == null ? null : new Date(json['created'])),
    };
}

  export function OrgFlagItemToJSON(json: any): OrgFlagItem {
      return OrgFlagItemToJSONTyped(json, false);
  }

  export function OrgFlagItemToJSONTyped(value?: OrgFlagItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'enabled': value['enabled'],
        'isGlobal': value['isGlobal'],
        'note': value['note'],
        'created': (value['created'] == null ? null : (value['created'] as any).toISOString()),
    };
}

